import { DropdownOptions } from '@com-delta-omnichannel/mach-core-js';
import {
  CheckInTextData,
  CheckInWidget,
  ShowError
} from '../models/check-in-widget.interfaces';

export const dropDownCheckInOptionMocks: DropdownOptions = {
  id: 'dropdownCheckIn',
  title: 'Find Your Trip By',

  items: [
    {
      label: 'Confirmation Number',
      value: 'Confirmation Number'
    },
    {
      label: 'Credit Card Number',
      value: 'Credit Card Number'
    },
    { label: 'Ticket Number', value: 'Ticket Number' },
    { label: 'SkyMiles Number', value: 'SkyMiles Number' }
  ],
  placeholder: 'Confirmation Number  '
};

export const checkInTextDataMock: CheckInTextData = {
  id: 'input-trip-by-value',
  title: 'Confirmation Number',
  inputLabel: 'Confirmation Number*',
  placeholder: 'ex. SFTORB',

  modalHeader: 'Where to locate a Confirmation Number?',
  modalContent:
    'Look for your 6 characters (example SFTORB) confirmation number in the confirmation/receipt email you received after purchasing your ticket.'
};
export const inputSelectedDropdownOptionMocks: CheckInTextData[] = [
  {
    id: 'input-trip-by-value',
    title: 'Confirmation Number',
    inputLabel: 'Confirmation Number*',
    placeholder: 'ex. SFTORB',
    modalHeader: 'Where to locate a Confirmation Number?',
    modalContent:
      'Look for your 6 characters (example SFTORB) confirmation number in the confirmation/receipt email you received after purchasing your ticket.'
  },
  {
    id: 'input-trip-by-value',
    title: 'Credit Card Number',
    inputLabel: 'Credit Card Number*',
    placeholder: 'ex. 1234123412341234',
    modalHeader: '',
    modalContent: ''
  },
  {
    id: 'input-trip-by-value',
    title: 'Ticket Number',
    inputLabel: 'Ticket Number*',
    placeholder: 'ex. 0062112549881',
    modalHeader: 'Where to locate a Ticket Number?',
    modalContent:
      'Look for your 13-digits (example 0062112549881) Ticket number in the confirmation/receipt email you received after purchasing your ticket.'
  },
  {
    id: 'input-trip-by-value',
    title: 'SkyMiles Number',
    inputLabel: 'SkyMiles Number*',
    placeholder: 'ex. 9876543210',
    modalHeader: '',
    modalContent: ''
  }
];

export const checkInWidgetMock: CheckInWidget = {
  inputSelectedDropdownOption: inputSelectedDropdownOptionMocks,
  dropDownCheckInOption: dropDownCheckInOptionMocks,
  checkInRedirectUrl: '/PCCOciWeb/app/index.html',
  labels: {
    lastNameLabel: 'Last Name*',
    fromAirportLabel: 'from Airport',
    buttonLabel: 'Search'
  },
  accessibility: {
    lastNameAriaLabel: 'ex. Smith',
    fromAirportAriaLabel: 'From Airport',
    buttonAriaLabel: 'City or Airport'
  },
  errors: {
    confirmationNumber: {
      invalid: 'Please enter a valid Confirmation Number',
      required: 'Please enter a Confirmation Number'
    },
    creditCardNumber: {
      invalid: 'Please enter a valid Card Number',
      required: 'Please enter a Card Number'
    },
    fromCity: {
      invalid: 'Please enter a valid Departure City',
      required: 'Please enter a Departure City'
    },
    last_Name: {
      invalid: 'Please enter a valid Last Name',
      required: 'Please enter a Last Name'
    },
    skymiles: {
      invalid: 'Please enter a valid SkyMiles Number',
      required: 'Please enter a Skymiles Number'
    },
    ticketNumber: {
      invalid: 'Please enter a valid Ticket Number',
      required: 'Please enter a Ticket Number'
    }
  },

  alertText: {
    subtitle: ' items indicated',
    title: 'To continue, please correct the '
  },
  nameLengthConfig: false
};
export const showError: ShowError = {
  showLastNameError: false,
  showTripTypeError: false,
  showOriginAirportError: false,
  showAlert: false,
  errorCount: 0,
  lastNameError: '',
  tripTypeError: '',
  originAirportError: ''
};
